import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { MatchValidatorDirective } from '../../../shared/validators/match.directive';
import { Observable } from 'rxjs/Observable';
import { PasswordRecoveryStepsService } from '../../services/password-recovery-steps.service';
import { IdentificationStepsService } from '../../services/identification-steps.service';

@Component({
    selector: 'payment-identification-password-recovery',
    templateUrl: './payment.identification.password-recovery.component.html',
    styleUrls: ['../../payment.component.scss'],
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MatchValidatorDirective,
        multi: true
    }]
})
export class PaymentIdentificationPasswordRecoveryComponent {
    public loading = false;
    public continueMethod: number = null;
    @Output() savedNewPassword: EventEmitter<any> = new EventEmitter();
    @Output() validatedToken: EventEmitter<string> = new EventEmitter();
    @Output() refusedToken: EventEmitter<null> = new EventEmitter();
    @Input() email = '';

    constructor(
        protected passwordRecoveryService: PasswordRecoveryStepsService,
        protected identificationStepsService: IdentificationStepsService
    ) {}

    /**
     * chosenContinueMethod event listener. Trigger token to inputter email.
     **/
    public onChosenContinueMethod(method: string) {
        this.loading = true;
        this.triggerToken(parseInt(method)).subscribe(() => {
            this.loading = false;
            this.continueMethod = parseInt(method);
        });
    }
    /**
     * saveNewPassword event listener. Emit savedNewPassword event.
     **/
    public onSaveNewPassword(token) {
        this.savedNewPassword.emit();
        this.loginWithToken(token);
    }
    /**
     * validatedToken event listener at create-password component.
     **/
    public onValidatedTokenDuringPasswordCreating(token) {
    }
    /**
     * This call only-token login method from service to request token from API.
     **/
    public loginWithToken(token) {
        this.loading = true;
        this.identificationStepsService
            .onlyTokenLogin(token)
            .subscribe(() => {
                this.loading = false;
            }, () => {
                this.loading = false;
                this.refusedToken.emit();
            });
    }
    /**
     * Reset continue method.
     **/
    public reset() {
        this.continueMethod=null;
    }

    /**
     * Call API to trigger token to inputted email.
     **/
    private triggerToken(type: number): Observable<any> {
        return new Observable(observable => {
            this.passwordRecoveryService.triggerToken(type)
                .subscribe(() => {
                    observable.next(null);
                    observable.complete();
                }, () => {
                    observable.error();
                });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/identification/password-recovery/payment.identification.password-recovery.component.ts